module.exports = __webpack_public_path__ + "img/montserrat-v14-cyrillic-ext_cyrillic_latin_latin-ext-300italic.svg";